// Libellés français de la maintenance et des papiers du camion, partagés par
// la fiche camion et la fiche maintenance (copiés de TruckMaintenancePage).

import { tableAvecRepli } from './libelles';

// Alias minces des domaines de `LIBELLES` (lib/libelles.js): une seule table de
// mots par notion. Un code absent se lit quand même en français.
export const WORK_STATUS_LABELS = tableAvecRepli('workStatus');
export const WORK_TYPE_LABELS = tableAvecRepli('workType');
export const SEVERITY_LABELS = tableAvecRepli('severity');
export const DOC_TYPE_LABELS = tableAvecRepli('docVehicule');
export const REASON_CODE_LABELS = tableAvecRepli('reasonCode');
export const DOC_COMPONENT_LABELS = tableAvecRepli('docComponent');
export const PRIORITY_LABELS = tableAvecRepli('priority');
export const BREAKDOWN_STATUS_LABELS = tableAvecRepli('breakdownStatus');
export const IMMO_STATUS_LABELS = tableAvecRepli('immobilisationStatus');
export const READING_TYPE_LABELS = tableAvecRepli('readingType');
export const TRIGGER_LABELS = tableAvecRepli('planTrigger');
